import { PrivacyRoute } from '@Core/Routes/PrivacyRoute'
import { IdentityLinking } from '@User/IdentityLinking/IdentityLinking'
import { RoutesPaths } from '@User/RoutesPaths'
import { UserDetails } from '@User/UserDetails/UserDetails'

import { UserList } from '@User/UserList/UserList'
import { roles } from '@User/roles'
import { Route } from 'react-router-dom'
const router = [
    <Route key={'UserStack'} path="/">
        <Route
            element={
                <PrivacyRoute permission={roles.user.permissions.read.key} />
            }
        >
            <Route path={RoutesPaths.UserList} element={<UserList />} />
            <Route path={RoutesPaths.UserDetail} element={<UserDetails />} />
        </Route>
        <Route
            element={
                <PrivacyRoute permission={roles.user.permissions.link.key} />
            }
        >
            <Route
                path={RoutesPaths.IdentityLinking}
                element={<IdentityLinking />}
            />
        </Route>
    </Route>,
]
export default router
